import * as React from "react";
import type { SVGProps } from "react";
const SvgServingFoodWithFullCloche = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.93 11H21c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1h1.07A8 8 0 0 1 11 4.07V3c0-.55.45-1 1-1s1 .45 1 1v1.07c3.61.45 6.48 3.32 6.93 6.93M16 16h3.16c.86 0 1.61.53 1.89 1.34.285.825-.004 1.827-.76 2.3l-3.3 1.94c-.46.27-.99.41-1.52.41h-5.13c-.32 0-.64-.05-.95-.15l-1.45-.48c-.15.37-.51.64-.93.64h-3c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v.13l.94-.63c.49-.33 1.07-.5 1.66-.5H14c1.1 0 2 .9 2 2M5 20h1v-4H5zm10.45 0c.18 0 .36-.05.51-.14h-.01L19.12 18h-5.13c-.55 0-1-.45-1-1s.45-1 1-1H10.6c-.2 0-.39.06-.56.17l-2.05 1.37v1.74l2.01.67c.11.03.21.05.32.05z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgServingFoodWithFullCloche;
